import {
  ExceptionOutlined,
  FieldTimeOutlined,
  FilterOutlined,
  GlobalOutlined,
  HomeOutlined,
  IdcardOutlined,
  MenuOutlined,
  ProfileOutlined,
  ScheduleOutlined,
  SettingOutlined,
  SolutionOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import routes from '@/constants/routes'
import { NotificationContext } from '@/contexts/Notification.context'

import {
  BellIcon,
  CustomerIcon,
  DetergentIcon,
  LaundryIcon,
  MachineIcon,
  TankIcon,
  WashingCountIcon,
  WashingHistoryIcon,
  WashingMethodIcon,
  WashingPartIcon,
} from './assets'
import { useAuth } from './useAuth'

const useMenu = () => {
  const { t } = useTranslation()
  const { hasPermission } = useAuth()

  const [notificationCount] = useContext(NotificationContext)

  const menus = [
    { name: t('components.layout.dashBoard'), icon: <HomeOutlined />, link: routes.home.path },
    {
      name: t('components.layout.clientDevice'),
      icon: <ProfileOutlined />,
      link: routes.clientDeviceByDay.path,
    },
    {
      name: t('components.layout.attendanceEmployee'),
      icon: <SolutionOutlined />,
      link: routes.attendanceEmployeeByDay.path,
    },
    {
      name: t('components.layout.attendance'),
      icon: <FilterOutlined />,
      link: routes.attendance.path,
    },
    { name: t('components.layout.employees'), icon: <UserOutlined />, link: routes.employees.path },
    {
      name: t('components.layout.admins'),
      icon: <IdcardOutlined />,
      link: routes.admins.path,
      isDisabled: !hasPermission('admin/view'),
    },
    {
      name: t('components.layout.settings'),
      icon: <SettingOutlined />,
      link: routes.languages.path,
      children: [
        {
          name: t('components.layout.languages'),
          icon: <GlobalOutlined />,
          link: routes.languages.path,
        },
        {
          name: t('components.layout.configTime'),
          icon: <FieldTimeOutlined />,
          link: routes.configs.path,
        },
        {
          name: t('components.layout.actionAdmin'),
          icon: <ScheduleOutlined />,
          link: routes.actionAdmin.path,
        },
        { name: t('components.layout.clientList'), icon: <UnorderedListOutlined />, link: routes.clients.path },
        { name: t('components.layout.deviceListError'), icon: <MenuOutlined />, link: routes.deviceError.path },
        { name: t('components.layout.incident'), icon: <ExceptionOutlined />, link: routes.incident.path },
      ],
    },
    {
      name: (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{t('components.layout.notification')}</span>
          <span style={{ color: '#f50' }}>{notificationCount || 0}</span>
        </div>
      ),
      icon: <BellIcon />,
      link: routes.notifications.path,
    },
    {
      name: t('components.layout.laundry'),
      icon: <LaundryIcon />,
      link: routes.laundry.path,
      children: [
        {
          name: t('components.layout.customer'),
          icon: <CustomerIcon />,
          link: routes.customers.path,
        },
        {
          name: t('components.layout.washingMachinePart'),
          icon: <WashingPartIcon />,
          link: routes.washingMachinePart.path,
        },
        {
          name: t('components.layout.machine'),
          icon: <MachineIcon />,
          link: routes.machines.path,
        },
        {
          name: t('components.layout.detergent'),
          icon: <DetergentIcon />,
          link: routes.detergents.path,
        },
        {
          name: t('components.layout.tank'),
          icon: <TankIcon />,
          link: routes.tanks.path,
        },
        {
          name: t('components.layout.washingMethod'),
          icon: <WashingMethodIcon />,
          link: routes.washingMethods.path,
        },
        {
          name: t('components.layout.washingCount'),
          icon: <WashingCountIcon />,
          link: routes.washingCountByDay.path,
        },
        {
          name: t('components.layout.washingHistory'),
          icon: <WashingHistoryIcon />,
          link: routes.washingHistory.path,
        },
      ],
    },
  ]
  return menus
}

export default useMenu
